import { useTranslation } from 'react-i18next'
import { Building2, Plus, Trash2 } from 'lucide-react'
import WizardModal, { inputCls, labelCls } from './WizardModal'
import { useWS } from '../contexts/WSContext'
import { apiError } from '../lib/api'

// Wizard de cadastro de Cliente: 1) dados básicos, 2) contas de administração.
export default function ClientWizard({ open, onClose, editing = null }) {
  const { t } = useTranslation()
  const { reloadAdmin } = useWS()

  const initial = {
    name: editing?.name || '',
    email: editing?.email || '',
    admins: Array.isArray(editing?.admin_accounts) ? editing.admin_accounts : [],
  }

  const steps = [
    {
      title: t('admin:clients.wizard.step_data'),
      valid: f => f.name.trim() !== '',
      render: (f, set) => (
        <div className="space-y-4">
          <label className="block"><span className={labelCls}>{t('admin:clients.wizard.name')}</span>
            <input value={f.name} onChange={e => set({ ...f, name: e.target.value })} placeholder={t('admin:clients.wizard.name_ph')} className={inputCls} autoFocus />
          </label>
          <label className="block"><span className={labelCls}>{t('admin:clients.wizard.email')}</span>
            <input type="email" value={f.email} onChange={e => set({ ...f, email: e.target.value })} placeholder={t('admin:clients.wizard.email_ph')} className={inputCls} />
          </label>
        </div>
      ),
    },
    {
      title: t('admin:clients.wizard.step_admins'),
      valid: f => f.admins.every(a => a.name.trim() !== '' && a.email.trim() !== ''),
      render: (f, set) => {
        const setAdmin = (i, patch) => set({ ...f, admins: f.admins.map((a, idx) => idx === i ? { ...a, ...patch } : a) })
        const delAdmin = (i) => set({ ...f, admins: f.admins.filter((_, idx) => idx !== i) })
        return (
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className={labelCls}>{t('admin:clients.wizard.admins_label')}</span>
              <button type="button" onClick={() => set({ ...f, admins: [...f.admins, { name: '', email: '' }] })}
                className="text-xs text-brand-600 hover:text-brand-700 inline-flex items-center gap-1"><Plus size={12} /> {t('admin:clients.wizard.add_account')}</button>
            </div>
            {f.admins.length === 0 && (
              <p className="text-xs text-slate-400 dark:text-slate-500">{t('admin:clients.wizard.no_accounts')}</p>
            )}
            {f.admins.map((a, i) => (
              <div key={i} className="flex items-center gap-2">
                <input value={a.name} onChange={e => setAdmin(i, { name: e.target.value })} placeholder={t('admin:clients.wizard.admin_name_ph')} className={inputCls + ' mt-0 flex-1'} />
                <input type="email" value={a.email} onChange={e => setAdmin(i, { email: e.target.value })} placeholder={t('admin:clients.wizard.admin_email_ph')} className={inputCls + ' mt-0 flex-1'} />
                <button type="button" onClick={() => delAdmin(i)} className="text-slate-300 dark:text-slate-600 hover:text-status-down"><Trash2 size={14} /></button>
              </div>
            ))}
          </div>
        )
      },
    },
  ]

  const finish = async (f) => {
    const body = { name: f.name.trim(), email: f.email.trim(), admin_accounts: f.admins }
    const url = editing ? `/api/clients/${editing.id}` : '/api/clients'
    const res = await fetch(url, { method: editing ? 'PUT' : 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
    if (!res.ok) throw await apiError(res)
    reloadAdmin()
  }

  return (
    <WizardModal
      open={open}
      onClose={onClose}
      title={editing ? t('admin:clients.edit') : t('admin:clients.add')}
      icon={<Building2 size={18} className="text-brand" />}
      steps={steps}
      initial={initial}
      onFinish={finish}
      finishLabel={editing ? t('common:actions.save') : t('admin:actions.register')}
    />
  )
}
